import { AppState } from '@/store/mainStore/state';
import { mutations } from '@/store/mainStore/mutations';
import { actions } from '@/store/mainStore/actions';
import { getters } from '@/store/mainStore/getters';
import { Module } from 'vuex';
import { RootState } from '@/store/root.state';

const namespaced = true;
export const mainStore: Module<AppState, RootState> = {
  namespaced,
  state: new AppState(),
  getters,
  actions,
  mutations,
};
